import React, { useEffect, useMemo, useState } from 'react';
import { getConfirmContext, confirmOutletSlot } from '../services/outletApi';
import { confirmScreenFromResult } from '../utils/confirmState';

// Aplana los grupos por profesional en una lista de horarios elegibles.
function flattenSlots(slots) {
  const out = [];
  (slots || []).forEach((prof) => {
    (prof.available_slots || []).forEach((s) => {
      out.push({
        id: s.id,
        date: s.date,
        init: s.init_str,
        end: s.end_str,
        professionalName: prof.professional_name,
      });
    });
  });
  return out;
}

export default function ClaimConfirmation({ token }) {
  const [screen, setScreen] = useState('loading');
  const [ctx, setCtx] = useState(null);
  const [selected, setSelected] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [booked, setBooked] = useState(null);

  useEffect(() => {
    let alive = true;
    getConfirmContext(token).then((res) => {
      if (!alive) return;
      setCtx(res);
      setScreen(confirmScreenFromResult(res));
    });
    return () => {
      alive = false;
    };
  }, [token]);

  const options = useMemo(() => flattenSlots(ctx && ctx.slots), [ctx]);

  const handleConfirm = async () => {
    if (!selected) return;
    setSubmitting(true);
    const res = await confirmOutletSlot(token, selected);
    setSubmitting(false);
    if (res.ok) {
      setBooked(res.consultation);
      setScreen('success');
    } else {
      setScreen(res.reason === 'already_confirmed' ? 'already' : 'taken');
    }
  };

  if (screen === 'loading') {
    return (
      <main className="claim-view">
        <p className="claim-muted">Cargando tu horario…</p>
      </main>
    );
  }

  if (screen === 'success' && booked) {
    return (
      <main className="claim-view">
        <h1 className="claim-title">Listo 🌷</h1>
        <p className="claim-body">
          Tu consulta de {booked.specialty_name} quedó agendada para el {booked.date} a las{' '}
          {booked.time} con {booked.professional_name}. Te esperamos en la app de Daisies.
        </p>
        <a
          className="claim-cta press-scale"
          href="https://descarga.daisies.mx"
          target="_blank"
          rel="noopener noreferrer"
        >
          Descargar la app
        </a>
      </main>
    );
  }

  if (screen === 'taken') {
    return (
      <main className="claim-view">
        <h1 className="claim-title">Ese horario ya se ocupó</h1>
        <p className="claim-body">
          Se nos adelantaron. Te avisamos por WhatsApp en cuanto se libere otro.
        </p>
      </main>
    );
  }

  if (screen === 'already') {
    return (
      <main className="claim-view">
        <h1 className="claim-title">Ya tienes tu consulta agendada</h1>
        <p className="claim-body">Te esperamos en la app de Daisies.</p>
      </main>
    );
  }

  if (screen === 'expired' || screen === 'invalid') {
    return (
      <main className="claim-view">
        <h1 className="claim-title">Este enlace ya no está disponible</h1>
        <p className="claim-body">
          Te avisamos por WhatsApp en cuanto se libere un horario para ti.
        </p>
      </main>
    );
  }

  // screen === 'choose'
  return (
    <main className="claim-view">
      <h1 className="claim-title">
        Hola {ctx.first_name} 🌷, se liberó un horario de {ctx.specialty_name}
      </h1>
      <p className="claim-body">Elige el que más te acomode y confírmalo para quedártelo.</p>
      <div className="claim-slots">
        {options.map((o) => (
          <button
            key={o.id}
            type="button"
            className={`claim-chip press-scale ${selected === o.id ? 'claim-chip--on' : ''}`}
            onClick={() => setSelected(o.id)}
          >
            {o.init} {o.professionalName ? `· ${o.professionalName}` : ''}
          </button>
        ))}
      </div>
      <button
        className="claim-cta press-scale"
        disabled={!selected || submitting}
        onClick={handleConfirm}
      >
        {submitting ? 'Confirmando…' : 'Confirmar mi horario'}
      </button>
    </main>
  );
}
